import { createContext } from 'react';
import { PageProps } from 'src/common/migration/PageProps';

export const GlobalPagePropsContext = createContext<PageProps>(undefined as unknown as PageProps);
